<template>
  <v-toolbar fixed flat id="titleBar" :height=40 style="top:60px;">
    <div v-for="item in screenList" v-bind:key="item">
      <v-btn
          flat
          :ref="item"
          class="titleBtn"
          :class="{activeTitleBtn:item == activeTab}"
          v-on:click="navTo(item)"
      > {{ item }}
      </v-btn>
    </div>
    <v-spacer/>
    <v-select dark v-model="select" :items="dropDownList" flat solo primary background-color='rgb(144,170,218)' style="height:100%; max-width:200px; margin-top:15px; margin-bottom:5px; font-size:18px;">
    </v-select>
  </v-toolbar>
</template>

<script>

import {store} from "../main.js";
import {getData} from "../getData.js";


var apiService;

export default {
  name: 'Titlebar',
  components: {},
  props: {},
  created() {
    if (!store.is_mobile()) {
      apiService = new getData(true);
    }

    let route_name = this.$route.name.replace('-', ' ')
    if (this.screenList.indexOf(route_name) > -1) {
      this.activeTab = route_name
    }
  },
  data() {
    return {
      dropDownList: ['Last Month', 'Last 3 Months', 'Last 6 Months', 'Last year'],
      screenList: ['Engines', 'Subsystems', 'Customers', 'Faults', 'Rulesets', 'Maintenance Tasks'],
      select: 'Last Month',
      activeTab: 'Engines'
    }
  },
  computed: {
    pageName: function () {
      return this.$route.name;
    }
  },
  watch: {
    select: function () {
      if (this.select != '') {
        apiService.getRealAggrData(this.select);

        this.placeholder = this.select;

        this.select = '';
      }
    },
    pageName: function (newName) {
      if (this.screenList.indexOf(newName) < 0) {
        this.activeTab = '';
      } else {
        this.activeTab = newName;
      }
    },
  },
  methods: {
    navTo(screen) {
      // screen = screen.replace(/\s+/g,'');

      this.activeTab = screen;
      this.$router.push({name: screen})
    },
  }
}
</script>

<style scoped>
#titleBar {
  background-color: rgb(244, 244, 244);
  padding: 0px;
  font-size: 24px;
  color: rgb(51, 82, 128);
}

.titleBtn {
  font-size: 20px;
  text-transform: none;
  display: inline-block;
  height: 100%;
}

.activeTitleBtn {
  color: rgb(51, 82, 128) !important;
  border-style: solid;
  border-color: rgb(51, 82, 128);
  border-width: 0px 0px 3px 0px;
}
</style>

<style>
.v-input__slot {
  min-height: 0px !important;
}

.alert {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 250px;
  height: 100px;
  background-color: white;
}
</style>